<template>
  <v-container grid-list-md fluid align-baseline pa-0>
  <v-layout row wrap>
    <v-flex xs12 sm6 offset-sm3 pa-0>
        <v-dialog
            v-model="dialogViewPost"
            fullscreen
            pa-0
            >
                   <v-card
                        class="mb-5"
                        color="white lighten-1"
                        ripple
                        >
                        <v-toolbar dark color="primary">
                            <v-toolbar-side-icon @click="dialogViewPost = false">
                            <v-icon>close</v-icon>
                                                          
                            </v-toolbar-side-icon>
                            <v-toolbar-title>View {{this.post.category.charAt(0).toUpperCase() + this.post.category.slice(1)}} Post</v-toolbar-title>
                            <v-spacer></v-spacer>

                        </v-toolbar>                        

                        <v-snackbar
                            v-model="showSnackbar"
                        >
                            {{snackbarText}}
                            <v-btn
                                color="pink"
                                flat
                                @click="showSnackbar = false"
                            >
                                Close
                            </v-btn>                            
                        </v-snackbar>



                        <v-card-title>
                            <v-layout row wrap>
                            <v-flex xs9>
                            <div class="title font-weight-bold pa-1">Post: {{post.subcategory.subcategorytitle}}</div>
                            </v-flex>
                            <v-flex xs3>
                            <div  @click="dialogDeletePost=true" class="caption primary--text" v-if="post.authorid===member.userid"><br/><v-icon color="primary" small>far fa-trash-alt</v-icon>Delete</div>
                            
                            </v-flex>
                            </v-layout>
                            <v-dialog
                            v-model="dialogDeletePost"                            
                            pa-0
                            >
                                <v-card>
                                    <v-card-text>
                                        Are you sure you want to delete this post?
                                        <v-btn flat small dark color="primary" @click="dialogDeletePost=false">Cancel</v-btn>
                                        <v-btn small dark color="primary" @click="deleteCurrentPost()">Yes, Delete Post</v-btn>
                                    </v-card-text>
                                </v-card>
                            </v-dialog>
                        </v-card-title>                        
                        <v-card-text>            
                            
                        <v-card>
                            <v-card-text>

                                <v-flex xs12 class="caption">


                                    <v-layout column>
                                        <v-flex>
                                            <v-layout pt-2 row>
                                                <v-flex ml-1 class="font-weight-bold flexlabel" xs3>
                                                    <v-tooltip bottom>
                                                    <span slot="activator">Title: <v-icon small>help</v-icon></span>
                                                    <span>{{listPostTypes.categorytitlehint}}}</span>
                                                    </v-tooltip>  
                                                </v-flex>
                                                <v-flex class="flexvalue caption" ml-2 xs9>
                                                    {{post.title}}
                                                </v-flex>                      
                                            </v-layout>
                                        </v-flex>
                                        <v-divider></v-divider>
                                    </v-layout>   
                                    <v-layout column>
                                        <v-flex>
                                            <v-layout pt-2 row>
                                                <v-flex ml-1 class="font-weight-bold flexlabel" xs3>
                                                    Author:
                                                </v-flex>
                                                <v-flex class="flexvalue caption" ml-2 xs9>
                                                    {{post.authorname}} - {{post.authorline}}   
                                                </v-flex>                      
                                            </v-layout>
                                        </v-flex>
                                        <v-divider></v-divider>
                                    </v-layout>    
                                    <v-layout column>
                                        <v-flex>
                                            <v-layout pt-2 row>
                                                <v-flex ml-1 class="font-weight-bold flexlabel" xs3>
                                                    Created:
                                                </v-flex>
                                                <v-flex class="flexvalue caption" ml-2 xs9>
                                                    {{post.datemodified}}  
                                                </v-flex>                      
                                            </v-layout>
                                        </v-flex>
                                        <v-divider></v-divider>
                                    </v-layout>  
                                    <v-layout column  v-if="listCategoryProperties.categoryoptionalfields.includes('eventdate') && post.eventdate">
                                        <v-flex>
                                            <v-layout pt-2 row>
                                                <v-flex ml-1 class="font-weight-bold flexlabel" xs3>
                                                    Event Date:
                                                </v-flex>
                                                <v-flex class="flexvalue caption" ml-2 xs9>
                                                    {{post.eventdate}}
                                                </v-flex>                      
                                            </v-layout>
                                        </v-flex>
                                        <v-divider></v-divider>
                                    </v-layout>  
                                    <v-layout column>
                                        <v-flex>
                                            <v-layout pt-2 row>
                                                <v-flex ml-1 class="font-weight-bold flexlabel" xs3>
                                                    Categories:
                                                </v-flex>
                                                <v-flex class="flexvalue caption" ml-2 xs9>
                                                    <div class="text-xs-left caption">
                                                        <slot v-for="ctag in post.categorytags">
                                                            <v-chip  class="caption" small color="primary lighten-2" text-color="white">{{ctag}}</v-chip>
                                                        </slot> 
                                                    </div> 
                                                </v-flex>                      
                                            </v-layout>
                                        </v-flex>
                                        <v-divider></v-divider>
                                    </v-layout>  
                                    <v-layout column v-if="listCategoryProperties.categoryoptionalfields.includes('location')">
                                        <v-flex>
                                            <v-layout pt-2 row>
                                                <v-flex ml-1 class="font-weight-bold flexlabel" xs3>
                                                    Location:
                                                </v-flex>
                                                <v-flex class="flexvalue caption" ml-2 xs9>
                                                    {{post.location}}
                                                </v-flex>                      
                                            </v-layout>
                                        </v-flex>
                                        <v-divider></v-divider>
                                    </v-layout>  
                                    <v-layout column  v-if="listCategoryProperties.categoryoptionalfields.includes('placename') && post.placename">
                                        <v-flex>
                                            <v-layout pt-2 row>
                                                <v-flex ml-1 class="font-weight-bold flexlabel" xs3>
                                                    Place:
                                                </v-flex>
                                                <v-flex class="flexvalue caption" ml-2 xs9>
                                                    {{post.placename}}
                                                </v-flex>                      
                                            </v-layout>
                                        </v-flex>
                                        <v-divider></v-divider>
                                    </v-layout>  
                                    <v-layout column v-if="listCategoryProperties.categoryoptionalfields.includes('address') && post.address">
                                        <v-flex>
                                            <v-layout pt-2 row>
                                                <v-flex ml-1 class="font-weight-bold flexlabel" xs3>
                                                    Address:
                                                </v-flex>
                                                <v-flex class="flexvalue caption" ml-2 xs9>
                                                    {{post.address}}
                                                </v-flex>                      
                                            </v-layout>
                                        </v-flex>
                                        <v-divider></v-divider>
                                    </v-layout>  
                                    <v-layout column  v-if="listCategoryProperties.categoryoptionalfields.includes('skilltags')">
                                        <v-flex>
                                            <v-layout pt-2 row>
                                                <v-flex ml-1 class="font-weight-bold flexlabel" xs3>
                                                    Skills:
                                                </v-flex>
                                                <v-flex class="flexvalue caption" ml-2 xs9>
                                                    <div class="text-xs-left">
                                                            <slot v-for="ctag in post.skilltags">
                                                                <v-chip  small class="caption" color="primary lighten-2" text-color="white">{{ctag}}</v-chip>
                                                            </slot> 
                                                    </div>  
                                                </v-flex>                      
                                            </v-layout>
                                        </v-flex>
                                        <v-divider></v-divider>
                                    </v-layout> 

                              
                                    </v-flex>

                            </v-card-text>
                        </v-card>

                    

                    <template>
                    <div class="subheading font-weight-medium pa-3">Details:</div>
                    <v-card raised> 
                        <v-card-text><div v-html="post.content"></div></v-card-text>
                    </v-card>
                    </template>

                    
                    <div class="subheading font-weight-medium pa-3"><v-icon>attachment</v-icon>File List:</div>
                    <v-card raised> 
                        
                        <v-card-text >

                            <template  v-if="postimages && postimages.length>0">
                                <v-subheader>View an image</v-subheader>
                            <div>
                                
                                <gallery :images="postimages" :index="index" @close="index = null"></gallery>
                                <v-avatar
                                    :tile=true
                                    size="150"
                                    v-for="(image, imageIndex) in postimages"
                                    :key="imageIndex"
                                    @click="index = imageIndex"
                                >
                                    <img :src="image">
                                </v-avatar>
                        
                            </div>
                            </template>

                            <template  v-if="post.files && post.files.length>0">
                                <v-subheader>Download a file</v-subheader>
                                <v-list>
                                    <template v-for="f in post.files" >
                                        <v-list-tile v-bind:key="'filelist-' + f.datecreated" @click="openFile(f.fileurl, '_blank')">
                                            <v-icon color="blue">cloud_download</v-icon>
                                            <v-list-tile-content>
                                                <v-list-tile-title >
                                                    <span class="font-weight-bold blue--text pl-2">{{f.filename.split('_')[1]}}</span>
                                                </v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon color="blue lighten-2">chevron_right</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                        <v-divider v-bind:key="'v-divider-' + f.datecreated"></v-divider>
                                    </template>
                                </v-list>
                        </template>                    
                        </v-card-text>
                        <v-card-actions>

                            <div>
                                <!--
                                <v-subheader>Upload a file</v-subheader>
                                <input type="file" accept=".jpg, .gif, .png, .doc, .docx, .xls, .xlsx, .pdf " @change="detectFiles($event.target.files)">
                                <v-progress-linear
                                v-if="progressUpload>0"                                
                                :size="100"
                                :width="15"
                                :value="progressUpload"
                                color="primary lighten-1"
                                >
                                {{ progressUpload }}                                    
                                </v-progress-linear>   
                                -->
                                <v-subheader @click="openFileDialog()" class="primary--text font-weight-bold caption"><v-icon>photo_camera</v-icon><v-icon>attachment</v-icon>Upload an File</v-subheader>
                                <input ref="fileinput" style="position:absolute;left:-200px;" type="file" accept="image/*" @change="detectFiles($event.target.files)">
                                <img ref="image_preview" style="position:absolute;top:-900px;" src=""/>
                                <v-progress-linear
                                v-if="progressUpload>0"
                                :size="100"
                                :width="15"
                                :value="progressUpload"
                                color="primary lighten-1"
                                >
                                {{ progressUpload }}                                    
                                </v-progress-linear>                                    
                            </div>                                                 
                        </v-card-actions>
                    </v-card>
                    



                    <div class="subheading font-weight-medium pa-3">Comments:</div>

                    <v-card>
                        <v-card-text>
                    <template v-for="c in post.comments" class="postComments">
                        <v-card v-bind:key="c.datecreated" flat>
<v-card-text>
    <div class="caption">
                                <v-avatar
                                            size="25" 
                                            color="grey lighten-2"
                                            ><img  v-bind:src="c.authoravatar"></v-avatar>
      
                            <b>{{c.authorname}} {{c.authorline}}</b></div> <div class="caption grey--text">{{c.datecreated}}: </div><div class="body-1 pa-0 lighten-2">{{c.comment}}</div></v-card-text>
                        </v-card>
                    </template>
                        </v-card-text>
                    </v-card>
                    <div class="subheading font-weight-medium pa-3">Add a Comment:</div>
                    <v-card flat>
                        <v-card-text>
                            <v-form v-model="validComment">
                            <v-layout>
                                
                            <v-flex xs12>
                                <v-textarea
                                    v-model="comment"
                                    label="Comments"
                                    placeholder="Enter comments and submit."
                                    auto-grow
                                    outline
                                    height=20
                                    append-outer-icon="send"
                                    :append-outer-icon-cb = "addComment"
                                    required                                    
                                    :rules="textareaRules"
                                ></v-textarea>
                            </v-flex>
                                
                    
                            </v-layout>
                            </v-form>
                        </v-card-text>
 
                    </v-card>

                        </v-card-text>

                   </v-card>
 



            </v-dialog>


        <v-dialog
            v-model="dialogAddPost"
            fullscreen
            pa-0
            >

                    <!-- TESTING REPLACEMENT SIMPLE FORM -->

                   <v-card
                        class="mb-5"
                        color="white lighten-1"
                        ripple
                        >
                        <v-toolbar dark color="primary">
                            <v-toolbar-side-icon @click="dialogAddPost = false">
                            <v-icon>close</v-icon>
                                                          
                            </v-toolbar-side-icon>
                            <v-toolbar-title>Create {{this.post.category.charAt(0).toUpperCase() + this.post.category.slice(1)}} Post</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn class="pr-4" icon @click="submitPost" :disabled="!validNewPost || !validNewPostDetails">
                            <v-icon>save</v-icon>save &nbsp;
                            </v-btn>
                        </v-toolbar>  

                        <v-card>
                            <v-card-text>

                        <v-form v-model="validNewPost">
                            <v-flex xs12>

   
                            <v-layout column>
                                <v-flex>
                                    <v-layout pt-2 row>
                                        <v-flex ml-1 class="font-weight-bold caption flexlabel" xs3>
                                            Post Type:
                                        </v-flex>
                                        <v-flex class="flexvalue caption" ml-2 xs9>
                                        <v-combobox
                                            v-model="post.subcategory"
                                            :items="listPostTypes.subcategories"
                                            chips
                                            label="Select post type"
                                            required
                                            :rules="dropdownRules"
                                            >
                                                <template  slot="item" slot-scope="data">                
                                                    <span v-if="data.item" style="width:200px;">{{ data.item.subcategorytitle }}</span><br/><span style="padding-left:20px;font-size:8px;">{{ data.item.subcategoryhint }}</span> 
                                                </template>                              
                                                <template  slot="selection" slot-scope="data">                
                                                    <span v-if="data.item" style="width:200px;">{{ data.item.subcategorytitle }}</span><br/><span style="padding-left:20px;font-size:8px;">{{ data.item.subcategoryhint }}</span> 
                                                </template>                              
                                            
                                            </v-combobox>
                                        </v-flex>                      
                                    </v-layout>
                                </v-flex>
                                <v-divider></v-divider>
                            </v-layout>    
                            <v-layout column>
                                <v-flex>
                                    <v-layout pt-2 row>
                                        <v-flex ml-1 class="font-weight-bold caption flexlabel" xs3>
                                            <v-tooltip bottom>
                                            <span slot="activator">Title: <v-icon small>help</v-icon></span>
                                            <span>{{listPostTypes.categorytitlehint}}}</span>
                                            </v-tooltip> 
                                        </v-flex>
                                        <v-flex class="flexvalue caption" ml-2 xs9>
                                            <v-text-field
                                                v-model="post.title"
                                                placeholder=""
                                                required
                                                :rules="textfieldRules"
                                            ></v-text-field>  
                                        </v-flex>                      
                                    </v-layout>
                                </v-flex>
                                <v-divider></v-divider>
                            </v-layout>   
                            <v-layout column v-if="listCategoryProperties.categoryoptionalfields.includes('location')">
                                <v-flex>
                                    <v-layout pt-2 row>
                                        <v-flex ml-1 class="font-weight-bold caption flexlabel" xs3>
                                            Location:
                                        </v-flex>
                                        <v-flex class="flexvalue caption" ml-2 xs9>
                                            <v-autocomplete
                                                v-model="post.location"
                                                :items="listLocations"
                                                persistent-hint
                                                required
                                                :rules="dropdownRules"
                                            >
                                            
                                            </v-autocomplete>    
                                        </v-flex>                      
                                    </v-layout>
                                </v-flex>
                                <v-divider></v-divider>
                            </v-layout>    
                            <v-layout column v-if="listCategoryProperties.categoryoptionalfields.includes('eventdate')">
                                <v-flex>
                                    <v-layout pt-2 row>
                                        <v-flex ml-1 class="font-weight-bold caption flexlabel" xs3>
                                            Event Date:
                                        </v-flex>
                                        <v-flex class="flexvalue caption" ml-2 xs9>
                                            <datetime v-model="post.eventdate" :use12-hour="true" type="datetime" value-zone="local" :minute-step="15" format="ff"></datetime>
                                        </v-flex>                      
                                    </v-layout>
                                </v-flex>
                                <v-divider></v-divider>
                            </v-layout>    
                            <v-layout column>
                                <v-flex>
                                    <v-layout pt-2 row>
                                        <v-flex ml-1 class="font-weight-bold caption flexlabel" xs3>
                                            Categories:
                                        </v-flex>
                                        <v-flex class="flexvalue caption" ml-2 xs9>
                                            <v-autocomplete
                                            :items="listPostTypes.listcategorytags"
                                            v-model="post.categorytags"
                                            multiple
                                            chips
                                            small
                                            color="primary lighten-2"
                                            >
                                                                    
                                            </v-autocomplete>  
                                        </v-flex>                      
                                    </v-layout>
                                </v-flex>
                                <v-divider></v-divider>
                            </v-layout>    
                            <v-layout column v-if="listCategoryProperties.categoryoptionalfields.includes('placename')">
                                <v-flex>
                                    <v-layout pt-2 row>
                                        <v-flex ml-1 class="font-weight-bold caption flexlabel" xs3>
                                            Place:
                                        </v-flex>
                                        <v-flex class="flexvalue caption" ml-2 xs9>
                                            <v-text-field
                                                v-model="post.placename"
                                                placeholder=""
                                                required
                                                :rules="textfieldRules"
                                            ></v-text-field>   
                                        </v-flex>                      
                                    </v-layout>
                                </v-flex>
                                <v-divider></v-divider>
                            </v-layout>  
                            <v-layout column  v-if="listCategoryProperties.categoryoptionalfields.includes('address')">
                                <v-flex>
                                    <v-layout pt-2 row>
                                        <v-flex ml-1 class="font-weight-bold caption flexlabel" xs3>
                                            Address:
                                        </v-flex>
                                        <v-flex class="flexvalue caption" ml-2 xs9>
                                            <v-text-field
                                                v-model="post.address"
                                                placeholder=""
                                                required
                                                :rules="textfieldRules"
                                            ></v-text-field>  
                                        </v-flex>                      
                                    </v-layout>
                                </v-flex>
                                <v-divider></v-divider>
                            </v-layout>    
                            <v-layout column  v-if="listCategoryProperties.categoryoptionalfields.includes('skilltags')">
                                <v-flex>
                                    <v-layout pt-2 row>
                                        <v-flex ml-1 class="font-weight-bold caption flexlabel" xs3>
                                            Skills:
                                        </v-flex>
                                        <v-flex class="flexvalue caption" ml-2 xs9>
                                             <v-autocomplete
                                                v-model="post.skilltags"
                                                :items="listCategorySkills"                            
                                                chips
                                                color="primary lighten-2"
                                                class="white--text"
                                                multiple
                                                small
                                            >
                                            
                                            </v-autocomplete>  
                                        </v-flex>                      
                                    </v-layout>
                                </v-flex>
                                <v-divider></v-divider>
                            </v-layout>    

                 
                            </v-flex>    
                        </v-form>

                    
                            </v-card-text>
                        </v-card>


                <v-form v-model="validNewPostDetails">
                   <template>
                    <div class="subheading font-weight-medium pa-3">Details:</div>
                    <v-card raised> 
                        <v-card-text>
                            <wysiwyg v-model="post.content" />
                            
                            <!--
                            <v-textarea
                            outline
                            name="input-content"
                            label="Enter the Post details"
                            v-model="post.content"
                            required
                            :rules="textareaRules"
                            ></v-textarea>                           
                            -->

                        </v-card-text>
                    </v-card>
                    </template>
                </v-form>
                
                    <div class="subheading font-weight-medium pa-3"><v-icon>attachment</v-icon>File List:</div>
                    <v-card raised> 
                        
                        <v-card-text >

                            <template  v-if="post.images && post.images.length>0">
                                <v-subheader>View an image</v-subheader>
                            <div>

<!--
                            <gallery  v-if="post.images && post.images.length>0" :images="post.images.map(i=>{return i.fileurl})" :index="index" @close="index = null"></gallery>
-->                            
                            <v-avatar
                                v-if="post.images && post.images.length>0"
                                :tile=true
                                size="80"
                                v-for="(image, imageIndex) in post.images.map(i=>{return i.fileurl})"
                                :key="imageIndex"
                                @click="index = imageIndex"
                            >
                                <img :src="image">
                            </v-avatar>                                
                                <!--
                                <gallery :images="post.images.map(i=>{return i.fileurl})" :index="index" @close="index = null"></gallery>
                                <v-avatar
                                    :tile=true
                                    size="150"
                                    v-for="(image, imageIndex) in post.images"
                                    :key="imageIndex"
                                    @click="index = imageIndex"
                                >
                                    <img :src="image.fileurl">
                                </v-avatar>
                                -->
                            </div>
                            </template>

                            <template  v-if="post.files && post.files.length>0">
                                <v-subheader>Download a file</v-subheader>
                                <v-list>
                                    <template v-for="f in post.files" >
                                        <v-list-tile v-bind:key="'filelist-' + f.datecreated" @click="openFile(f.fileurl, '_blank')">
                                            <v-icon color="blue">cloud_download</v-icon>
                                            <v-list-tile-content>
                                                <v-list-tile-title >
                                                    <span class="font-weight-bold blue--text pl-2">{{f.filename.split('_')[1]}}</span>
                                                </v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon color="blue lighten-2">chevron_right</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                        <v-divider v-bind:key="'v-divider-' + f.datecreated"></v-divider>
                                    </template>
                                </v-list>
                        </template>  


                        </v-card-text>
                        <v-card-actions>
                 
                            <div>
                                <!--
                                <input type="file" multiple accept="image/jpeg" @change="detectFiles($event.target.files)">
                                <v-progress-linear
                                v-if="progressUpload>0"
                                :rotate="360"
                                :size="100"
                                :width="15"
                                :value="progressUpload"
                                color="primary lighten-1"
                                >
                                {{ progressUpload }}                                    
                                </v-progress-linear>
                                -->
                                <v-subheader @click="openFileDialog()" class="primary--text font-weight-bold caption"><v-icon>photo_camera</v-icon><v-icon>attachment</v-icon>Upload a File</v-subheader>
                                <input ref="fileinput" style="position:absolute;left:-200px;" type="file" accept="image/*" @change="detectFiles($event.target.files)">
                                <img ref="image_preview" style="position:absolute;top:-900px;" src=""/>
                                <v-progress-linear
                                v-if="progressUpload>0"
                                :size="100"
                                :width="15"
                                :value="progressUpload"
                                color="primary lighten-1"
                                >
                                {{ progressUpload }}                                    
                                </v-progress-linear>                                   
                            </div>                                                         
                        </v-card-actions>
                    </v-card>



            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn  dark color="primary" :disabled="!validNewPost || !validNewPostDetails"  @click="submitPost">
                            <v-icon>save</v-icon>save
                            </v-btn>                
            </v-card-actions>


            </v-card>
                    <!-- END TESTING REPLACEMENT SIMPLE FORM -->




            </v-dialog>
    </v-flex>
  </v-layout>
  <v-layout row wrap>


    <v-flex xs12>
            <v-btn
              color="accent"
              dark
              absolute
              top
              right
              fab
              @click="dialogAddPost=true"
            >
              <v-icon>add</v-icon>
            </v-btn>

        <div class="font-weight-medium title pa-1">List of {{this.$route.name}} Posts</div>

        <v-list three-line >
          <template v-for="(item, index) in categoryPosts">
            <v-list-tile :key="index" avatar ripple @click="viewPost(item)">
              <v-list-tile-avatar>
                <img :src="item.authoravatar">
              </v-list-tile-avatar>                
              <v-list-tile-content>
                <v-list-tile-title> {{ item.title }}</v-list-tile-title>
                <!--<v-list-tile-sub-title class="text--primary">{{ new Date(item.datecreated).toLocaleDateString('en-GB', { day : 'numeric', month : 'short', year : 'numeric' }) }} - posted by {{ item.authorname }} </v-list-tile-sub-title>-->
                <v-list-tile-sub-title ><span v-html="item.content "></span> </v-list-tile-sub-title>
              </v-list-tile-content>

            </v-list-tile>

            <v-divider v-if="index + 1 < categoryPosts.length" :key="`divider-${index}`"></v-divider>
          </template>
        </v-list>
    </v-flex>

  </v-layout>
  </v-container>
</template>

<script>
import VueGallery from 'vue-gallery'
 import firebase from 'firebase'
 import moment from 'moment'
import storage from 'firebase/storage'
import { Datetime } from 'vue-datetime'
import wysiwyg from "vue-wysiwyg"

const DATEFORMAT = "ddd, MMM D h:mmA"


  export default {
    data () {
        return {  
            validNewPost: false,
            validNewPostDetails: false,
            validComment: false,
            textareaRules: [
                v => !!v || 'Field is required',
                v => (v && v.length >= 10) || 'Field must be greater than 10 characters'
            ],            
            textfieldRules: [
                v => !!v || 'Field is required',
                v => (v && v.length >= 10) || 'Field must be greater than 10 characters'
            ],
            dropdownRules: [
                v => !!v || 'Field is required'
            ],            
            progressUpload: 0,
            file: File,
            fileIsImage: false,
            filename: null,
            filetype: null,
            filepath: null,
            uploadTask: '',            
            
            index: null,

            tmpFileName: null,
            storageBucket: 'appfiles/',
            storageFullPath: '',
            datemodal: false,            
            timemodal: false,  
            dialogAddPost: false,
            dialogViewPost: false,
            dialogDeletePost: false,
            e1: 0,
            comment: null,
            showSnackbar: false,
            snackbarText: null,
            post:{
                postid: null,
                isPost: true,
                title: null,
                authorid: null,
                authorname: null,
                authorline: null,
                authoravatar: null,
                org: 'opp',
                chapter: 'zz',
                scope: 'chapter',
                datecreated: null,
                datemodified: null,
                category: null,
                subcategory: '',
                categorytags: [],
                skilltags: [],
                content: '',
                postdatetime: null,
                location: '',
                files: [],
                images: [],
                featuredimage: '',
                comments: [],
                participatingmemberids: []

            },
            emptypost: null
            
        }
    },
    components: {
        'gallery': VueGallery,
        'datetime': Datetime
    },
    created () {
        this.emptypost = this.post
        this.comment = null
        this.post.category = this.$route.path.substring(1)        

        //TODO: variablize the entire page to be used for all post types based this.$route.path
        //console.log('.............route.name = ' , this.$route)
       
    },
    computed: {
      myColor () {
         return this.$store.getters.myColor
      },         
      user () {
        return this.$store.getters.user
      },
      member () {
        return this.$store.getters.member
      },
      colorMain () {
          return this.$store.getters.colorMain
      },
      listPostTypes () {
          return this.$store.getters.listPostTypes[this.$route.path.substring(1)]
      },      
      listLocations () {
          return this.$store.getters.listLocations
      },
      listCategorySkills () {
          return this.$store.getters.listPostTypes[this.$route.path.substring(1)].listcategoryskills.sort((a,b)=>{
            if(a.toLowerCase() < b.toLowerCase()){
                return -1
            }else if(b.toLowerCase() < a.toLowerCase()){
                return 1
            }else{
                return 0
            }

          })
      },
      listCategoryProperties (){
          return this.$store.getters.listPostTypes[this.$route.path.substring(1)]
      },      
      categoryPosts () {       
          //console.log('categoryPosts',this.$route.name ,this.$store.getters[this.$route.path.substring(1) + 'Posts'])   
          return this.$store.getters[this.$route.path.substring(1) + 'Posts']
      },
      postimages () {
          var rtn = null
          if(this.post && this.post.images && this.post.images.length>0){
              rtn = this.post.images.map(i=>{
                  return i.fileurl

              })
          }
          return rtn
      }             
    },
    watch: {
          dialogViewPost(value) {
            if(value===false){
                this.post = this.emptypost
                this.comment = null
                this.tmpFileName=null
                this.snackbarText=null                
            }
        },
        dialogAddPost(value) {
            if(value===false){
                this.post = this.emptypost
                this.comment = null
                this.tmpFileName=null
                this.snackbarText=null
            }
        },        
        categoryPosts (value) {
            //console.log('categoryPosts watcher -->value',  value)
            if(this.dialogViewPost){
                var tmppostid = this.post.postid
                var updatedPost = value.filter(function(p){
                    return p.postid === tmppostid
                })
                //console.log('categoryPosts updated while dialogViewPost is true', updatedPost)
                if(updatedPost && updatedPost.length===1){
                    //console.log('setting this.post = updatedPost[0]')
                    this.post = updatedPost[0]
                }
                
            }
        },        
        tmpFileName (value){
            if(value){
                this.storageFullPath = this.storageBucket + value
            }
        },
        uploadTask: function(value) {
            value.on('state_changed', sp => {
                this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
            }, 
            null, 
            () => {
                value.snapshot.ref.getDownloadURL().then(downloadURL => {
                    //console.log('downloadURL', downloadURL)
                    this.$emit('url', downloadURL)

                    this.$store.dispatch('addFileToUploadHistory', {post: this.post, fileurl: downloadURL, filepath: this.filepath}).then(errmsg => {
                        //console.log('msg', errmsg)
                        if(errmsg && errmsg ==='failure'){
                            console.error('posts addFileToUploadHistory', errmsg) 
                        }else{
                            //console.log('successfully added file addFileToUploadHistory') 

                            //TEMPORARILY DISPLAY THE IMAGE IN THE POST
                            var objFile = new Object()
                            objFile.fileurl = downloadURL
                            objFile.filename =this.filename
                            if(this.filetype){
                                objFile.filetype =this.filetype
                            }                
                            objFile.datecreated = new Date().getTime()                            
                            if(this.fileIsImage){
                                //this.post.images.push(downloadURL)
                                this.post.images.push(objFile)
                            }else{
                                //this.post.files.push(downloadURL)
                                this.post.files.push(objFile)
                            }                    
                            if(this.dialogViewPost){
                                //UPDATE THE POST IN THE DB

                                this.$store.dispatch('addFileToPost', {post: this.post, fileurl: downloadURL, filename: this.filename , filetype: this.filetype, isImage: this.fileIsImage, filepath: this.filepath}).then(errmsg => {
                               //this.$store.dispatch('addFileToGallery', {member: this.member, post: this.post, fileurl: downloadURL, filename: this.filename , filetype: this.filetype, isImage: this.fileIsImage, filepath: this.filepath}).then(errmsg => { //testing the gallery code
                                    //console.log('msg', errmsg)
                                    if(errmsg && errmsg ==='failure'){
                                        console.error('addFileToPost', errmsg) 
                                    }else{
                                        //console.log('successfully added file to post') 
                                        
                                    }
                                })                                                           
                            }
                            this.fileIsImage = false
                            this.filename = null
                            this.filetype = null
                            this.filepath = null

                        }
                    })                      

                })
            })
        }        
    },
    methods: {
      openFileDialog: function (){
        var inputbutton = this.$refs.fileinput
        //console.log('inputbutton',inputbutton)
        inputbutton.click()

      },         
      step1: function () {
        this.e1 = 1
      },      
      step2: function () {
        this.e1 = 2
      },
      step3: function () {
        this.e1 = 3

      },
      step4: function () {
        this.e1 = 4

      },
      viewPost: function (p) {
          //console.log('called viewPost')
          this.post = p
          this.dialogViewPost = true

      },
      addComment: function () {
        
        if(this.comment && this.validComment===true){
            var dt = new Date();
            var tmpdatemodified = dt.getTime();            
            var tmporg = this.post.org
            var tmppostid = this.post.postid
            var tmpcomment = this.comment
            var objComment = new Object()
            var tmpuserid = this.$store.getters.member.userid
            objComment.userid = tmpuserid
            objComment.authorname = this.$store.getters.member.firstname + ' ' + this.$store.getters.member.lastname
            objComment.authorline = this.$store.getters.memberLine.lineyear + ' (' + this.$store.getters.memberLine.lineseason + ')'
            objComment.authoravatar = this.$store.getters.user.photoUrl
            if(this.$store.getters.member.profilepic && this.$store.getters.member.profilepic.fileurl){
                objComment.authoravatar = this.$store.getters.member.profilepic.fileurl
            }            
            objComment.comment = tmpcomment
            objComment.datecreated = tmpdatemodified
            var tmppayload = new Object()
            tmppayload.org =tmporg
            tmppayload.postid = tmppostid
            tmppayload.comment = objComment
            //console.log('addComment dispatching addCommentToPost w/ payload',tmppayload)
            this.$store.dispatch('addCommentToPost', tmppayload).then(errmsg => {
            //console.log('msg', errmsg)
            if(errmsg && errmsg ==='failure'){
                console.error('addCommentToPost', errmsg) 
                this.snackbarText="Error posting comment."
                this.showSnackbar=true
            }else{
                this.comment=null
                this.snackbarText="Comment successfully posted."
                this.showSnackbar=true
            }
            })   
        }
     
      },
      submitPost: function () {
        var dt = new Date()
        var tmpdatemodified = dt.getTime()

        var tmporg = this.$store.getters.org
        var tmpchapter = this.$store.getters.chapter
        var tmpuserid = this.$store.getters.member.userid
        var tmpauthorname = this.$store.getters.member.firstname + ' ' + this.$store.getters.member.lastname
        var tmpauthorline = this.$store.getters.memberLine.lineyear + ' (' + this.$store.getters.memberLine.lineseason + ')'
        var tmpauthoravatar = this.$store.getters.user.photoUrl
        if(this.$store.getters.member.profilepic && this.$store.getters.member.profilepic.fileurl){
            tmpauthoravatar = this.$store.getters.member.profilepic.fileurl
        }           

        this.post.isactive = true

        if(this.post.authorid === null){
            this.post.authorid = tmpuserid
        }

        if(this.post.authorname === null){
            this.post.authorname = tmpauthorname
        }   
        
        if(this.post.authorline === null){
            this.post.authorline = tmpauthorline
        }         

        if(this.post.authorid === null){
            this.post.authorid = tmpuserid
        }  

        if(this.post.authoravatar === null){
            this.post.authoravatar = tmpauthoravatar
        }            

        if(this.post.datecreated === null){
            this.post.datecreated = tmpdatemodified
        }

        if(this.post.chapter === null){
            this.post.chapter = tmpchapter
        }
        
        if(this.post.org === null){
            this.post.org = tmporg
        }    
        
         

        this.post.datemodified = tmpdatemodified


        if(this.post.postid === null){
            //var docid = tmporg + '_' + tmpchapter + '_post_' + this.post.category + '_' + this.post.authorid + '_' + this.post.datecreated
            var docid = 'posts/' + tmpchapter + '/' + this.post.category + '_' + this.post.authorid + '_' + this.post.datecreated
            this.post.postid = docid
        }

        this.$store.dispatch('writePostToDb', this.post).then(errmsg => {
          //console.log('msg', errmsg)
          if(errmsg && errmsg ==='failure'){
            console.error('writePostToDb', errmsg) 
          }else{
              this.dialogAddPost=false
              this.post = null
          }
        })

      },
      deleteCurrentPost: function(){
        this.post.isactive   = false
        this.$store.dispatch('writePostToDb', this.post).then(errmsg => {
          //console.log('msg', errmsg)
          if(errmsg && errmsg ==='failure'){
            console.error('writePostToDb', errmsg) 
          }else{
              this.post = null
              this.dialogAddPost=false
              
          }
        })
      },
      getStorage: function () {
            return firebase.storage()
      },
      getFileName: function (file){
            var dt = new Date();
            var tmpdatemodified = dt.getTime()            
          this.tmpFileName = tmpdatemodified + '_' + file.name
          return this.tmpFileName
      },
      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },      
      onUploadViewPost: function ({doUpload}){
            //console.log('doUpload', {doUpload})

            doUpload()
            var dt = new Date();
            var tmpdatemodified = this.tmpFileName.substring(0, this.tmpFileName.indexOf('_'))         
            var objFile = new Object ()
            objFile.location =  this.storageBucket +  this.tmpFileName
            if(this.tmpFileName && (this.tmpFileName.toLowerCase().indexOf('jpg') || this.tmpFileName.toLowerCase().indexOf('png') || this.tmpFileName.toLowerCase().indexOf('gif'))){
                objFile.type = 'image'
            }else{
                objFile.type = 'document'
            }
            objFile.datecreated = tmpdatemodified
            objFile.userid = this.$store.getters.member.userid

            //console.log('Updating post with new file info -> addFileToPost', objFile)

            
            this.$store.dispatch('addFileToPost', {post: this.post, objfile: objFile}).then(errmsg => {
            //console.log('msg', errmsg)
            if(errmsg && errmsg ==='failure'){
                console.error('addFileToPost', errmsg) 
            }else{
                //console.log('successfully added file to post') 
            }
            })   

      },
      onUploadNewPost: function ({doUpload}){
            //console.log('doUpload', {doUpload})

            doUpload()
            var dt = new Date();
            var tmpdatemodified = this.tmpFileName.substring(0, this.tmpFileName.indexOf('_'))         
            var objFile = new Object ()
            objFile.location =  this.storageBucket +  this.tmpFileName
            if(this.tmpFileName && (this.tmpFileName.toLowerCase().indexOf('jpg') || this.tmpFileName.toLowerCase().indexOf('png') || this.tmpFileName.toLowerCase().indexOf('gif'))){
                objFile.type = 'image'
            }else{
                objFile.type = 'document'
            }
            objFile.datecreated = tmpdatemodified
            objFile.userid = this.$store.getters.member.userid
            

            //console.log('addFileToUploadHistory', objFile)
            
            
            this.$store.dispatch('addFileToUploadHistory', {org: this.post.org, chapter: this.post.chapter, objfile: objFile}).then(errmsg => {
            //console.log('msg', errmsg)
            if(errmsg && errmsg ==='failure'){
                console.error('post addFileToUploadHistory', errmsg) 
            }else{
                //console.log('successfully added file addFileToUploadHistory') 
                this.post.files.push(objFile)
            }
            })   

      },      
      onDelete: function({doDelete}){
          //console.log('doDelete', {doDelete})
          //doDelete()
      },
        detectFiles: function (fileList) {
        Array.from(Array(fileList.length).keys()).map( x => {
            this.upload(fileList[x])
        })
        },
        upload: function (file) {
            if(file.type.indexOf('image')>-1){
                this.fileIsImage = true
                var dataUrl = "";
                // Create an image
                var img = document.createElement("img");
                img.addEventListener('load', ()=> {
                // execute drawImage statements here
                   var canvas = document.createElement("canvas");
                    //var canvas = $("<canvas>", {"id":"testing"})[0];
                    var ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0);            
                    // Set Width and Height
                    var MAX_WIDTH = 400;
                    var MAX_HEIGHT = 300;
                    var width = img.width;
                    var height = img.height;            
                    if (width > height) {
                    if (width > MAX_WIDTH) {
                        height *= MAX_WIDTH / width;
                        width = MAX_WIDTH;
                    }
                    } else {
                    if (height > MAX_HEIGHT) {
                        width *= MAX_HEIGHT / height;
                        height = MAX_HEIGHT;
                    }
                    }
                    canvas.width = width;
                    canvas.height = height;
                    var ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0, width, height);            
                    //console.log('calling canvas',canvas)
                    dataUrl = canvas.toDataURL(file.type);                    
                    this.$refs.image_preview.src = dataUrl;    
                    //console.log('calling dataUrl', dataUrl)
                    this.filename = new Date().getTime() + '_' + file.name
                    this.filetype = file.type
                    this.filepath = this.post.org + '_' + this.post.chapter + '/posts_' + this.post.category + '/' + this.filename

                    this.uploadTask = firebase.storage().ref(this.filepath).putString(dataUrl, 'data_url')
                }, false);            
                // Create a file reader
                var reader = new FileReader();
                // Set the image once loaded into file reader
                reader.onload = (e)=>
                {
                    //console.log('calling reader.onload  e', e)

                    img.src = e.target.result;
                    //console.log('calling reader.onload  img', img)                   
                }
                // Load files into file reader
                reader.readAsDataURL(file);               

            }else{
                this.filename = new Date().getTime() + '_' + file.name
                this.filetype = file.type
                this.filepath = this.post.org + '_' + this.post.chapter + '/posts_' + this.post.category + '/' + this.filename
                this.uploadTask = firebase.storage().ref(this.filepath).put(file);

            }
        },         
        /*
        upload: function (file) {
            if(file.type.indexOf('image')>-1){
                this.fileIsImage = true
            }
            
            this.filename = new Date().getTime() + '_' + file.name
            this.filetype = file.type
            this.filepath = this.post.org + '_' + this.post.chapter + '/posts_' + this.post.category + '/' + this.filename
            this.uploadTask = firebase.storage().ref(this.filepath).put(file);
        },
        */
        openFile: function(f){
            window.open(f,'_blank')
        }     

    }
  }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#postFieldList .v-subheader{
    width:110px;
    padding-left: 0px;
    background-color: ghostwhite;
    margin-right: 8px;
}

#postComments .v-card{
    background-color:blue;
}
#fieldContainer .v-card__text{
    padding:5px;
}
.fieldlabel, .fieldlabel .v-card{
    background-color: ghostwhite;
    text-align: left;
}

.progress-bar {
  margin: 10px 0;
}


</style>